
    import "src/app/AppWms/SettingsPage/Profile/index.module.scss?farm_css_modules";
    
    export default {"header": `header-931fe16c`,"profilePage": `profilePage-931fe16c`,"title": `title-931fe16c`}
    